import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useRequest } from "../../api/utils/useRequest";
import { BalootUserAPIs } from "../../api/APIs";
import { LoadingButton } from "@mui/lab";
import { onlyHasPersianChar } from "../../utils/validations";
import { CancelOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { setConfig } from "../../store/actions/ConfigActions";

function LastNamePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [lastName, setLastName] = useState("");
  const location = useLocation();
  const firstName = location.state?.firstName || "";
  const { config } = useSelector((state) => state.config);

  const { loading, apiCall: savePersonalInfo } = useRequest(
    BalootUserAPIs.savePersonalInfo
  );

  const onSubmit = () => {
    savePersonalInfo({
      data: {
        firstName,
        lastName,
      },
      onSuccess: () => {
        dispatch(
          setConfig({
            config: {
              personalInfo: {
                ...config.personalInfo,
                firstName: firstName,
                lastName: lastName,
              },
            },
          })
        );
        navigate("../../referral");
      },
    });
  };
  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton
            onClick={() => {
              navigate(-1);
            }}
          >
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            ساخت حساب بلوط
          </Typography>
        }
      />
      <PageContentContainer sx={{ overflow: "auto" }}>
        <Box>
          <Typography component={"div"}>
            <Box
              display={"inline"}
              sx={{ typography: "body2", color: "grey.2" }}
            >
              نام خانوادگی
            </Box>{" "}
            <Box
              display={"inline"}
              sx={{ typography: "subtitle1", color: "grey.4" }}
            >
              (مطابق کارت ملی)
            </Box>
          </Typography>
          <TextField
            name="last-name"
            value={lastName}
            error={lastName.length > 1 && !onlyHasPersianChar(lastName)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {lastName.length > 0 && (
                    <IconButton
                      onClick={() => {
                        setLastName("");
                      }}
                    >
                      <CancelOutlined sx={{ fontSize: 20 }} />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
            onChange={(event) => {
              if (event.target.value === null) {
                setLastName("");
              } else {
                event.target.value.length < 20 &&
                  setLastName(event.target.value);
              }
            }}
            sx={{ mt: "12px" }}
            fullWidth
            placeholder="نام خانوادگی خود را وارد نمایید"
          />
        </Box>
        <Box
          sx={{
            flex: 1,
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            mt: 2,
          }}
        >
          <Box>
            <LoadingButton
              loading={loading}
              disabled={lastName.length < 2 || !onlyHasPersianChar(lastName)}
              onClick={onSubmit}
              variant="contained"
              color="primary"
              sx={{ height: 56, width: 48 }}
            >
              <ArrowBackIcon sx={{ color: "common.white", fontSize: 24 }} />
            </LoadingButton>
          </Box>
        </Box>
      </PageContentContainer>
    </>
  );
}

export default LastNamePage;
